import { ArrowUp } from 'lucide-react';
import { SITE, SOCIAL } from '../data/site';
import { useLocalTime } from '../hooks/useLocalTime';
import SectionLink from './SectionLink';

export default function Footer() {
  const time = useLocalTime(SITE.timezone);

  return (
    <footer className="px-6 lg:px-10 pb-10">
      <div className="max-w-page mx-auto border-t border-line pt-8 flex flex-col md:flex-row md:items-center justify-between gap-6 font-mono text-[11px] text-faint">
        <p>
          © {new Date().getFullYear()} {SITE.name} · {SITE.location} · {time} IST
        </p>
        <ul className="flex flex-wrap gap-x-5 gap-y-2">
          {SOCIAL.map((s) => (
            <li key={s.label}>
              <a
                href={s.href}
                target={s.href.startsWith('http') ? '_blank' : undefined}
                rel={s.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                className="hover:text-ink transition-colors"
              >
                {s.label}
              </a>
            </li>
          ))}
        </ul>
        <SectionLink href="#home" className="inline-flex items-center gap-2 hover:text-ink transition-colors">
          Back to top
          <ArrowUp size={12} aria-hidden="true" />
        </SectionLink>
      </div>
    </footer>
  );
}
